import React, { useEffect, useState } from 'react';
import styles from './visualNote.module.css';
import Notes from './notas.js';
import { MdClose } from 'react-icons/md';
import { useAppContext } from "../../../AppContext.js";
import { MdAdd, MdRemove } from 'react-icons/md';



const VisualNote = ({
    data,
    onClose,
    onSaveEdit,
    onTrash,
    onArchive,
    onTogglePriority,
    onRefresh,
    dragActive,
    //fontSize,
    visualNotes,
    filter,
    onEditing,
    onEditDoubleclick
}) => {
    const { isApp } = useAppContext();
    const [fontSize, setFontSize] = useState(() => Number(localStorage.getItem("visualNoteFontSize")) || 16); //tamanho da fonte da nota //tamanho da fonte da nota
    // const [isEditingNote, setIsEditingNote] = useState(false);

    useEffect(() => {
        document.body.style.overflow = "hidden";
        const handleEsc = (e) => {
            if (e.key === "Escape") {
                onClose();
            }
        };
        window.addEventListener("keydown", handleEsc);
        return () => {
            document.body.style.overflow = "";
            window.removeEventListener("keydown", handleEsc);
        };
    }, [onClose]);

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    const handleCloseButton = () => {
        onClose();
    };

    return (
        <div className={styles.overlay} onClick={handleOverlayClick}>
            <div className={`${styles.card} ${isApp ? styles.cardApp : ''}`}>
                <div className={styles.closeContainer}>
                    {/* controle do tamanho da fonte */}
                    <div className={styles.fontSizeControl}>
                        <button
                            type="button"
                            className={styles.fontSizeButton}
                            onClick={() => {
                                const newSize = fontSize - 1;
                                if (newSize < 10) return;
                                setFontSize(newSize);
                                localStorage.setItem("visualNoteFontSize", newSize);
                            }}
                            aria-label="Diminuir tamanho da fonte"
                            title="Diminuir tamanho da fonte"
                        >
                            <MdRemove size={18} />
                        </button>
                        <button
                            type="button"
                            className={styles.fontSizeButton}
                            onClick={() => {
                                const newSize = fontSize + 1;
                                if (newSize > 20) return;
                                setFontSize(newSize);
                                localStorage.setItem("visualNoteFontSize", newSize);
                            }}
                            aria-label="Aumentar tamanho da fonte"
                            title="Aumentar tamanho da fonte"
                        >
                            <MdAdd size={18} />
                        </button>
                    </div>
                    <button
                        type="button"
                        className={styles.close}
                        onClick={handleCloseButton}
                        aria-label="Close"
                        title="Close"
                    >
                        <MdClose size={18} />
                    </button>
                    {/* categoria da nota */}
                    <div className={styles.noteCategoria}>
                    </div>
                </div>
                <div className={styles.noteWrapper}>
                    <Notes
                        data={data}
                        onSaveEdit={onSaveEdit}
                        onTrash={onTrash}
                        onArchive={onArchive}
                        onTogglePriority={onTogglePriority}
                        onRefresh={onRefresh}
                        dragActive={dragActive}
                        fontSize={fontSize}
                        visualNotes={visualNotes}
                        filter={filter}
                        onEditing={(status) => {
                            // setIsEditingNote(status);
                            if (onEditing) onEditing(status);
                        }}
                        onEditDoubleclick={(n) => { onClose(); onEditDoubleclick(n); }}
                        onDoubleclickNote={null} // Definir como null para o menu esconder o botão expandir
                    />
                </div>
            </div>
        </div>
    );
};

export default VisualNote;
